import script from "./ChatHistoryDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatHistoryDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ChatHistoryDialog.vue?vue&type=style&index=0&id=421d4bc2&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-421d4bc2"]])

export default __exports__